export default {
  actions: {
    estimateList(ctx) {
      ctx.commit('updateEstimateList', [])
    },
    estimateDirectories(ctx) {
      ctx.commit('updateEstimateDirectories', null)
    }
  },
  mutations: {
    updateEstimateList(state, list) {
      state.estimateList = list
    },
    updateEstimateDirectories(state, directories) {
      state.estimateDirectories = directories
    }
  },
  state: {
    estimateList: [],
    estimateDirectories: null,
  },
  getters: {
    getEstimateList(state) {
      return state.estimateList
    },
    getEstimateDirectories(state) {
      return state.estimateDirectories
    }
  }
}